import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { PasswordModule } from 'primeng/password';
import { FormComponent, RowComponent, FieldComponent } from '@src/app/components';
import { KeyValueArrayComponent } from '@src/app/modules/key-value-array';
import { OpenEditorComponent } from '@src/app/components';

import { FormType, SourceTypes } from './types';
import { DEFAULT_VALUES, METHODS, SOURCE_TYPES, HEADERS_KEYS, HEADERS_VALUES, API_ENDPOINTS } from './constants';

@Component({
  selector: 'datasource-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormComponent,
    RowComponent,
    FieldComponent,
    InputTextModule,
    InputTextareaModule,
    DropdownModule,
    PasswordModule,
    KeyValueArrayComponent,
    OpenEditorComponent,
  ],
  templateUrl: './datasource-form.component.html',
  styleUrl: './datasource-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DatasourceFormComponent {
  @Input() form!: FormGroup<FormType>;
  @Input() sourceTypes = SOURCE_TYPES;
  @Input() dependsOnValue: string[] = [];
  @Input() loading = false;

  readonly defaultValues = DEFAULT_VALUES;
  readonly methods = METHODS;
  readonly headersKeys = HEADERS_KEYS;
  readonly headersValues = HEADERS_VALUES;
  readonly apiEndpoints = API_ENDPOINTS;
  readonly types = SourceTypes;

  get typeControl() {
    return this.form.controls.type;
  }

  get queryControl() {
    return this.form.controls.query;
  }

  get bodyControl() {
    return this.form.controls.body;
  }
}
